// Grupos de un buzon personal (D62): un grupo cuyo correo es el correo personal de alguien del equipo (p. ej. "Jahir"
// -> jlmoreno@) recibe casos de un buzon que solo lee su dueno (D38). Esos casos los ve solo el dueno: ni el
// administrador ni otros miembros, que igual no podrian abrir el correo. Los demas grupos los ve solo quien es miembro:
// ser administrador no da acceso a los casos de un grupo (D83). `existentes`: todos los grupos activos, para saber que
// casos no tienen un grupo del CRM ("Sin grupo del CRM").
type Grupo = { nombre: string; correo?: string | null; miembros: string[]; activo?: boolean };
type Miembro = { id: string; email?: string | null };

export function gruposVisibles(grupos: Grupo[], miembros: Miembro[], yo: { miembroId?: string | null; admin: boolean }) {
  const duenoDe = new Map(miembros.filter((m) => m.email).map((m) => [m.email!.trim().toLowerCase(), m.id]));
  const activos = grupos.filter((g) => g.activo !== false);
  const dueno = (g: Grupo) => duenoDe.get(String(g.correo ?? '').trim().toLowerCase()) ?? null;
  // Un grupo personal de otra persona no se ve (aunque se sea administrador o miembro).
  const ajeno = (g: Grupo) => {
    const d = dueno(g);
    return !!d && d !== yo.miembroId;
  };
  const miembro = activos.filter((g) => !!yo.miembroId && g.miembros.includes(yo.miembroId) && !ajeno(g)).map((g) => g.nombre);
  const nombres = [...miembro].sort((a, b) => a.localeCompare(b));
  return { nombres, miembro, existentes: activos.map((g) => g.nombre) };
}
